import Model, { attr } from '@ember-data/model';

export default class AddressPlaceModel extends Model {
  @attr('string') city;
  @attr('string') state;
  @attr('string') street;
  @attr('string') zip;
}
